import { Component, Input, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { Models } from '@ibexfusion/models';
import { MatDialog } from '@angular/material/dialog';
import { AssetSelectorComponent } from '../../../../../components/asset-selector/asset-selector.component';
import { EnvironmentService } from '@services/environment/environment.service';
import { IbexCheckboxComponent } from '../../../../../components/ibex-checkbox/ibex-checkbox.component';
import { MediaAssetsService } from '@services/assets/media-assets.service';

@Component({
    selector: 'logo',
    templateUrl: './logo.component.html',
    styleUrls: ['./logo.component.scss'],
    providers: [MediaAssetsService],
    standalone: false
})
export class LogoComponent implements OnInit {

  @Input() dynamicContent;
  @Input() imagesOnly = false;
  @Input() imageOnly = false;
  @ViewChild('checkboxAll') checkboxAll: IbexCheckboxComponent;
  @ViewChildren(IbexCheckboxComponent) checkboxes!: QueryList<IbexCheckboxComponent>;
  public mediaAssetPath: any;
  public asset;
  public timestamp = Date.now();
  selectedFiles = [];
  checkBoxActions = [{ translation: 'dynamicContent.disconnectMultipleItems', icon: 'delete', action: () => { this.disconnectSelectedItems()} }];

  constructor(
    private dialog: MatDialog, private mediaAssetsService: MediaAssetsService, private environmentService: EnvironmentService
  ) {
    this.mediaAssetPath = this.environmentService.getMediaAssetPath();
  }

  async ngOnInit() {
    if (this.dynamicContent?.content?.otherLogo) {
      this.initAsset();
    }
  }

  private async initAsset() {
    let path = JSON.parse(JSON.stringify(this.dynamicContent.content.otherLogo));
    path = path.split('media/')[1];
    path = path.split('?')[0];
    let secondPath = JSON.parse(JSON.stringify(this.dynamicContent.content.otherLogo));
    secondPath = secondPath.split('?')[0];
    const asset = await this.mediaAssetsService.find(0, 1, { $or: [{ path: { $in: [path, secondPath] } }, { url: { $in: [path, secondPath] } }] });
    if (asset.data.length) {
      this.asset = asset.data[0];
    }
  }

  public async chooseFromMediaAssets(): Promise<any> {
    const asset: Models.MediaAsset = await this.dialog.open(AssetSelectorComponent, { width: '448px', height: '550px', data: { type: 'media' } }).afterClosed().toPromise();
    if (!!asset) {
      this.dynamicContent.content.otherLogo = this.mediaAssetPath + asset.path + '?t=' + Date.now();
      this.initAsset();
    }
  }

  public disconnectSelectedItems() {
    for (const file of this.selectedFiles) {
      this.dynamicContent.mediaFiles.splice(this.dynamicContent.mediaFiles.findIndex(el => el.url === file.url), 1);
    }
    this.selectedFiles = [];
    this.checkboxes.forEach(checkbox => { checkbox.unselect(); });
  }

}
